export const BOARD_COLUMNS = [
  { id: 'new', title: 'Mới', color: '#6366f1' },
  { id: 'in_progress', title: 'Đang làm', color: '#f59e0b' },
  { id: 'on_hold', title: 'Đang treo', color: '#ef4444' },
  { id: 'in_review', title: 'Đang Review', color: '#a855f7' },
  { id: 'done', title: 'Đã xong', color: '#22c55e', collapsible: true, defaultCollapsed: false },
  { id: 'cancelled', title: 'Huỷ', color: '#64748b', collapsible: true, defaultCollapsed: true },
];
